import React from 'react'
import styled from 'styled-components'
import { theme } from '../../theme/theme'
import PropTypes from 'prop-types'
import Spacer from '../../uielements/Spacer'
import CustomImage from '../../uielements/Image'
import Button from '../../uielements/Button'
import { useTranslation } from 'react-i18next'
import { screenSizes } from '../../lib/constants'

const BlockWrapper = styled.div`
    background: #fff;
    border-radius: 30px;
    box-shadow: 0 0 8px ${theme.lightBlue};
    padding: 30px 15px;
    height: 50vh;
    flex-basis: calc(50% - 20px);
    width: calc(50% - 20px);
    margin: 25px 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (max-width: ${screenSizes.lg}px) {
        flex-basis: calc(50% - 20px);
        margin: 25px 10px;
        height: 60vh;
    }

    @media (max-width: ${screenSizes.md}px) {
        flex-basis: calc(100% - 20px);
        margin: 25px 10px;
    }
`

const Title = styled.div`
    display: block;
    color: ${theme.blue};
    font-weight: bold;
    font-size: 2rem;
    text-align: center;

    @media (max-width: ${screenSizes.xl}px) {
        font-size: 1.6rem;
    }

    @media (max-width: ${screenSizes.lg}px) {
        font-size: 1.4rem;
    }

    @media (max-width: ${screenSizes.md}px) {
        font-size: 1.2rem;
    }
`

const ImageWrapper = styled.div`
    display: inline-block;
    margin: 5px auto;
    max-width: 90px;

    @media (max-width: ${screenSizes.xl}px) {
        max-width: 90px;
    }

    @media (max-width: ${screenSizes.lg}px) {
        max-width: 80px;
    }

    @media (max-width: ${screenSizes.md}px) {
        max-width: 70px;
    }
`

const ButtonWrapper = styled.div`
    display: inline-block;
    margin: 0 auto;
`

const TextWrapper = styled.div`
    text-align: center !important;
`

const RegBlock = (props) => {
    const { t } = useTranslation()

    return (
        <BlockWrapper>
            <Title>{props.title}</Title>
            <ImageWrapper>
                <CustomImage obj={props.icon} />
            </ImageWrapper>
            <TextWrapper>{props.children}</TextWrapper>
            <ButtonWrapper>
                <Button link={'/registrations/' + props.slug} textColor={theme.blue} arrowColor="blue">
                    {t('read-more-no-tone')}
                </Button>
            </ButtonWrapper>
        </BlockWrapper>
    )
}

RegBlock.defaultProps = {
    title: 'some title',
    slug: 'some-link',
    icon: 'https://via.placeholder.com/140x140',
}

RegBlock.propTypes = {
    title: PropTypes.string,
    slug: PropTypes.string,
    icon: PropTypes.object,
}

export default RegBlock
